module.exports = __webpack_public_path__ + "img/ColoredSpace0.91591bde.jpg";